<div class="login-container" *ngIf="!isLoggedIn">
  <div class="card login-card">
    <div class="card-body">
      <img src="https://www.viniinternational.com/wp-content/uploads/2022/02/website-logo-main.png"
           alt="Company Logo" class="company-logo mb-3">
      <h3 class="text-center mb-4">Login</h3>
      <form name="form" (ngSubmit)="f.form.valid && onSubmit()"
            #f="ngForm" novalidate>
        <div class="form-group">
          <label>Username</label>
          <input  type="text" class="form-control" name="username"
                  [(ngModel)]="form.username" required #username="ngModel"
                  placeholder="Enter Username">
          <div class="alert alert-danger" role="alert" *ngIf="username.errors && f.submitted">
            Username is required!
          </div>
        </div>
        <div class="form-group">
          <label>Password</label>
          <div class="input-group">
            <input [type]="isPasswordVisible ? 'text' : 'password'" class="form-control"
                   name="password" [(ngModel)]="form.password"
                   required minlength="6" #password="ngModel" placeholder="Enter Password"/>
            <div class="input-group-append">
              <span class="input-group-text" (click)="togglePasswordVisibility()" style="cursor: pointer;">
                <i class="fa" [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'"></i>
              </span>
            </div>
          </div>
          <div class="alert alert-danger" role="alert" *ngIf="password.errors && f.submitted">
            <div *ngIf="password.errors.required">Password is required</div>
          </div>
        </div>

        <label>
          <input type="checkbox" name="rememberMe" [(ngModel)]="rememberMe" /> Remember Me
        </label>

        <button type="submit" class="btn btn-primary btn-block"
                [disabled]="isLoading"><i *ngIf="isLoading" class="fa fa-spinner fa-spin"></i> Login</button>
        <div class="form-group">
          <div
            class="alert alert-danger"
            role="alert"
            *ngIf="f.submitted && isLoginFailed">
            Login failed: {{ errorMessage }}
          </div>
        </div>
      </form>
      <div class="d-flex justify-content-between login-bottom text-primary">
        <a routerLink="/register">Sign Up</a>
        <a (click)="openForgotPasswordDialog()">Forgot password?</a>
      </div>
    </div>
  </div>
</div>


<!--<div class="col-md-12">
  <div class="card card-container">
    <img
      id="profile-img"
      src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
      class="profile-img-card"/>
    <form *ngIf="!isLoggedIn" name="form" (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm" novalidate>
      <div class="form-group">
        <label>Username</label>
        <input
          type="text"
          class="form-control"
          name="username"
          [(ngModel)]="form.username"
          required
          #username="ngModel"/>
        <div class="alert alert-danger"
          role="alert"
          *ngIf="username.errors && f.submitted">
          Username is required!
        </div>
      </div>
      <div class="form-group">
        <label>Password</label>
        <input
          type="password"
          class="form-control"
          name="password"
          [(ngModel)]="form.password"
          required
          minlength="6"
          #password="ngModel"/>
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="password.errors && f.submitted">
          <div *ngIf="password.errors.required">Password is required</div>
          <div *ngIf="password.errors.minlength">
            Password must be at least 6 characters
          </div>
        </div>
      </div>
      <div class="form-group">
        <button class="btn btn-primary btn-block">
          Login
        </button>
      </div>
      <div class="form-group">
        <div
          class="alert alert-danger"
          role="alert"
          *ngIf="f.submitted && isLoginFailed">
          Login failed: {{ errorMessage }}
        </div>
      </div>
    </form>

    <div class="alert alert-success" *ngIf="isLoggedIn">
      Logged in as {{ roles }}.
    </div>
  </div>
</div>-->
